<template>
  <div class="auth-wrapper auth-page">
    <div class="auth-card">
      <slot name="card"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthWrapperV2",
}
</script>

<style lang="scss">
@import '@core/scss/base/pages/app-general.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>

<style lang="scss" scoped>
.auth-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 2rem 1rem;
  box-sizing: border-box;
  background: linear-gradient(160deg, #f5f7fb 0%, #ebeff7 100%);
}

.auth-card {
  width: 100%;
  min-width: 0;
  max-width: 440px;
  margin: auto;
  box-sizing: border-box;
  padding: 2.75rem 2.25rem;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 20px 50px -12px rgba(1, 17, 81, 0.15), 0 2px 8px rgba(1, 17, 81, 0.06);
  overflow-wrap: break-word;
}

@media (max-width: 420px) {
  .auth-card {
    padding: 2rem 1.25rem;
    border-radius: 16px;
  }
}

.dark-layout .auth-page {
  background: transparent;
}

.dark-layout .auth-card {
  background: #283046;
  box-shadow: 0 20px 50px -12px rgba(0, 0, 0, 0.4);
}
</style>
